const loaded = new Set();

export const preloadCountingImages = async () => {
  if (loaded.size === 23) return; 

  const promises = [];

  for (let i = 1; i <= 23; i++) {
    if (loaded.has(i)) continue;

    loaded.add(i);

    promises.push(
      new Promise(resolve => {
        const img = new Image();
        img.src = `/backGrounds/counting/${i}.svg`;
        img.onload = resolve;
        img.onerror = resolve;
      })
    );
  }

  await Promise.all(promises);
};
